var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#5F6F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1852 15.8889H19.2593V20.2222H21.1852V15.8889ZM23.1111 17.3333V14.4444C23.1111 13.6467 22.2488 13 21.1852 13H19.2593C18.1956 13 17.3333 13.6467 17.3333 14.4444V17.3333H14.4444C13.6467 17.3333 13 17.98 13 18.7778V22.3889V26V27.4444V31.0556V32.5V37.5556C13 38.3533 13.6467 39 14.4444 39H37.5556C38.3533 39 39 38.3533 39 37.5556V32.5V31.0556V27.4444V26V22.3889V18.7778C39 17.98 38.3533 17.3333 37.5556 17.3333H34.6667V14.4444C34.6667 13.6467 33.8044 13 32.7407 13H30.8148C29.7512 13 28.8889 13.6467 28.8889 14.4444V17.3333H23.1111ZM36.1111 26V22.3889H32.5V26H36.1111ZM31.0556 26V22.3889H26.7222V26H31.0556ZM25.2778 26H20.9444V22.3889H25.2778V26ZM25.2778 27.4444V31.0556H20.9444V27.4444H25.2778ZM26.7222 31.0556V27.4444H31.0556V31.0556H26.7222ZM25.2778 32.5H20.9444V36.1111H25.2778V32.5ZM26.7222 36.1111V32.5H31.0556V36.1111H26.7222ZM32.5 32.5V36.1111H36.1111V32.5H32.5ZM32.5 27.4444V31.0556H36.1111V27.4444H32.5ZM19.5 26V22.3889H15.8889V26H19.5ZM15.8889 27.4444H19.5V31.0556H15.8889V27.4444ZM15.8889 36.1111V32.5H19.5V36.1111H15.8889ZM32.7407 15.8889V20.2222H30.8148V15.8889H32.7407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.08e2cc03d18ef2ecf03139bea0d83c82.svg";
export { ForwardRef as ReactComponent };